/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateMissingReceiptCardPolicyRequest,
  DefaultPolicyCardTypesResponse,
  MissingReceiptCardPolicyDto,
  MissingReceiptPolicyPreviewDto,
  UpdateMissingReceiptCardPolicyRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiMissingReceiptPolicyController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-missing-receipt-policy-controller
   * @name GetMissingReceiptPolicyById
   * @request GET:/api/v1/missing-receipts-policy/{id}
   */
  getMissingReceiptPolicyById = (id: string, params: RequestParams = {}) =>
    this.http.request<MissingReceiptCardPolicyDto, any>({
      path: `/v1/missing-receipts-policy/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMissingReceiptPolicyByIdPath = '/v1/missing-receipts-policy/${id}'
  static getMissingReceiptPolicyByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-missing-receipt-policy-controller
   * @name UpdateMissingReceiptPolicy
   * @request PUT:/api/v1/missing-receipts-policy/{id}
   */
  updateMissingReceiptPolicy = (
    id: string,
    data: UpdateMissingReceiptCardPolicyRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<MissingReceiptCardPolicyDto, any>({
      path: `/v1/missing-receipts-policy/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateMissingReceiptPolicyPath = '/v1/missing-receipts-policy/${id}'
  static updateMissingReceiptPolicyMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-missing-receipt-policy-controller
   * @name CreateMissingReceiptPolicy
   * @request POST:/api/v1/missing-receipts-policy
   */
  createMissingReceiptPolicy = (
    data: CreateMissingReceiptCardPolicyRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<MissingReceiptCardPolicyDto, any>({
      path: `/v1/missing-receipts-policy`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createMissingReceiptPolicyPath = '/v1/missing-receipts-policy'
  static createMissingReceiptPolicyMethod = 'POST'
  /**
   * No description
   *
   * @tags api-missing-receipt-policy-controller
   * @name CreatePolicyPreview
   * @request POST:/api/v1/missing-receipts-policy/preview
   */
  createPolicyPreview = (data: CreateMissingReceiptCardPolicyRequest, params: RequestParams = {}) =>
    this.http.request<MissingReceiptPolicyPreviewDto, any>({
      path: `/v1/missing-receipts-policy/preview`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPolicyPreviewPath = '/v1/missing-receipts-policy/preview'
  static createPolicyPreviewMethod = 'POST'
  /**
   * No description
   *
   * @tags api-missing-receipt-policy-controller
   * @name GetMissingReceiptPoliciesByOrgId
   * @request GET:/api/v1/missing-receipts-policy/organisation
   */
  getMissingReceiptPoliciesByOrgId = (params: RequestParams = {}) =>
    this.http.request<MissingReceiptCardPolicyDto[], any>({
      path: `/v1/missing-receipts-policy/organisation`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getMissingReceiptPoliciesByOrgIdPath = '/v1/missing-receipts-policy/organisation'
  static getMissingReceiptPoliciesByOrgIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-missing-receipt-policy-controller
   * @name GetActiveDefaultMissingReceiptPolicy
   * @request GET:/api/v1/missing-receipts-policy/card-types/active
   */
  getActiveDefaultMissingReceiptPolicy = (params: RequestParams = {}) =>
    this.http.request<DefaultPolicyCardTypesResponse, any>({
      path: `/v1/missing-receipts-policy/card-types/active`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActiveDefaultMissingReceiptPolicyPath = '/v1/missing-receipts-policy/card-types/active'
  static getActiveDefaultMissingReceiptPolicyMethod = 'GET'
}
